import { action as apiAction } from 'api/Api'
import {
  setResponsible,
  addUser,
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  userId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, userId } = payload

  const state = getState()

  const currentResponsible = state['view-board'].cards[cardId].responsible

  let optimisticAction
  if (currentResponsible) {
    optimisticAction = optimisticDispatch(dispatch, addUser({
      id: cardId,
      userId: userId,
      index: undefined
    }))
  } else {
    optimisticAction = optimisticDispatch(dispatch, setResponsible({
      id: cardId,
      responsible: userId
    }))
  }

  try {
    await apiAction('AddUserToCard', {
      cardId,
      userId
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}
